<template>
	<div class="wrap">
		<div class="login-box">
			<img class="logo" src="@/assets/images/logo-horizontal.png" />
			<div class="login-title">
				<div class="tt">云上乡村管理系统</div>
				<div class="tt-en">Cloud Village MANAGEMENT</div>
			</div>
			<div v-if="!isLogin" class="login-content">
				<el-form ref="vForm" class="form" :model="vForm">
					<el-form-item class="form-group" prop="loginName" :rules="validator.loginName">
						<el-input v-model="vForm.loginName" class="form-control" placeholder="账号" clearable></el-input>
					</el-form-item>
					<el-form-item class="form-group" prop="password" :rules="validator.password">
						<el-input v-model="vForm.password" class="form-control" placeholder="密码" show-password></el-input>
					</el-form-item>
					<div class="login-btn-box">
						<el-button class="login-btn" :loading="loginLoading" type="primary" @click="login">登录</el-button>
					</div>
				</el-form>
			</div>
			<div v-if="isLogin" v-loading="loading" class="login-content">
				<div class="login-btn-box">
					<div class="user-info">
						<div>已登录账号：{{ userInfo.nickname }}</div>
						<div v-if="userInfo.subjectInfo" class="v-font-12 v-color-gray v-mr-10">（{{ userInfo.subjectInfo.name }}）</div>
						<router-link to="/saas" replace><el-button type="success" size="small">登录</el-button></router-link>
					</div>
					<el-button class="login-btn" type="primary" @click="changAccount">切换账号</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import validator from "./validator";
	import cookie from "@/api/cookie";

	export default {
		data() {
			return {
				loginLoading: false,
				validator, //表单验证
				vForm: {
					loginName: "",
					password: ""
				},
				loading:false,
				isLogin:!!cookie.getToken(),
				userInfo:{}
			};
		},

		created() {
			if(this.isLogin){
				this.getUserInfo();
			}else{
				document.addEventListener("keydown", this.bindDoLogin);
			}
		},

		destroyed() {
			document.removeEventListener("keydown", this.bindDoLogin);
		},

		methods: {
			bindDoLogin(e) {
				if (e.keyCode == 13) {
					this.login();
				}
			},

			async getUserInfo(){
				this.loading = true;
				try{
					let res = await this.api.user.info();
					this.userInfo = res.data;
				}catch (e) {
					this.isLogin = false;
					console.error(e)
				}
				this.loading = false;
			},

			changAccount(){
				cookie.removeToken();
				this.isLogin = false;
			},

			//账号密码登录
			async login() {
				this.loginLoading = true;
				try {
					await this.$refs.vForm.validate();
					let res = await this.api.user.login(this.vForm);
					cookie.setToken(res.data.userToken);
					this.$store.commit('user/SET_USERINFO',null);
					if (this.$route.query.forward) {
						location.href = decodeURIComponent(this.$route.query.forward);
					} else {
						this.$router.replace("/saas/works");
					}
				} catch (e) {
					console.error(e);
				}
				this.loginLoading = false;
			}
		}
	};
</script>

<style scoped lang="scss">
	.wrap {
		height: 100vh;
		background: url("../../assets/images/login-bg.png") no-repeat center;
		background-size: cover;
		position: relative;
	}

	.login-box {
		width: 878px;
		height: 450px;
		border-radius: 6px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		box-sizing: border-box;
		background: #fff url("../../assets/images/login-box-bg.png") left center no-repeat;
		background-size: auto 100%;
	}

	.logo {
		position: absolute;
		display: block;
		top: 40px;
		left: 40px;
		width: 180px;
	}

	.login-title {
		width: 354px;
		position: absolute;
		top: 40px;
		left: 480px;
		text-align: center;

		.tt {
			font-size: 24px;
			font-weight: bold;
		}

		.tt-en {
			font-size: 18px;
			color: #999;
		}
	}

	.login-content {
		position: absolute;
		top: 150px;
		left: 480px;
		width: 354px;
	}

	.login-btn-box {
		margin-top: 50px;
	}

	input::-webkit-input-placeholder {
		font-size: 14px;
		color: #cacaca;
	}

	.login-btn {
		display: block;
		width: 100%;
		font-size: 16px;
		letter-spacing: 6px;
		background: linear-gradient(
				180deg,
				rgba(62, 144, 255, 1) 0%,
				rgba(21, 113, 238, 1) 100%
		);
		border-radius: 35px;
		border: 0;
		height: 50px;

		&:hover,
		&:focus {
			background: linear-gradient(
					180deg,
					rgba(62, 144, 255, 1) 0%,
					rgba(21, 113, 238, 1) 100%
			);
		}
	}

	.login-box ::v-deep .form-control .el-input__inner {
		border-width: 0;
		border-radius: 20px;
		padding-left: 30px;
		height: 50px;
		background: #f6f6f6;
	}
	.user-info{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 70px;
	}

</style>
